import Amplitude from '@/amplitude-events/sidemenu.amplitude'
import { EXTERNAL_ENDPOINTS } from '@/external-endpoints'

const SHOP = ({ merchantId, accountId, shop }) => ({
  label: 'sidemenu.external.shop',
  id: 'link-shop-menu',
  click: () => {
    Amplitude.events.quickLinks.shopButtonClicked()
    windowOpen(EXTERNAL_ENDPOINTS.SHOP.url(merchantId, accountId))
  },
  conditional: shop?.conditional ?? false,
  icon: 'shop'
})

const HUB = ({
  merchantId,
  accountId,
  componentIsEnabled,
  permissionIsEnabled
}) => ({
  label: 'sidemenu.external.hub',
  id: 'link-hub-menu',
  click: () => {
    Amplitude.events.quickLinks.hubButtonClicked()
    windowOpen(EXTERNAL_ENDPOINTS.HUB.url(merchantId, accountId))
  },
  conditional:
    componentIsEnabled('apps', 'hub') && permissionIsEnabled('links.hub:get'),
  icon: 'menu-grid'
})

const SIMULATOR = ({ simulator }) => ({
  label: 'sidemenu.external.simulator',
  id: 'link-simulator-menu',
  click: () => {
    Amplitude.events.quickLinks.simulatorButtonClicked()
    simulator && simulator.actionToggleDrawer()
  },
  active: simulator?.getToggleDrawer,
  conditional: simulator?.conditional ?? false,
  icon: 'percent-box'
})

function windowOpen (url) {
  return window.open(url, '_blank')
}

const EXTERNAL_FOOTER = args => [SHOP, HUB, SIMULATOR].map(menu => menu(args))

export { SHOP, HUB, SIMULATOR }

export default EXTERNAL_FOOTER
